export const CURRENT_YEAR = new Date().getFullYear();
